import React, { useState, useEffect } from 'react'
import { DataTable, TextInput, Button } from '@paypalcorp/pp-react'
import Fuse from 'fuse.js'
import { values } from 'lodash'

const CodeCell = (value) => {
  return <code>{value.value}</code>
}

const LocaleCell = ({ value }) => {
  if (value) {
    return value.map((val) => <code>{val}</code>)
  } else {
    return <code>...loading</code>
  }
}

const allRows = [
  {
    id: 'row1',
    country: { value: 'ALBANIA' },
    code: { value: 'AL' },
    locales: { value: ['en_AL'] },
  },
  {
    id: 'row2',
    country: { value: 'ALGERIA' },
    code: { value: 'DZ' },
    locales: { value: ['ar_DZ', 'en_DZ', 'fr_DZ', 'es_DZ', 'zh_DZ'] },
  },
  {
    id: 'row3',
    country: { value: 'ANDORRA' },
    code: { value: 'AD' },
    locales: { value: ['en_AD', 'fr_AD', 'es_AD', 'zh_AD'] },
  },
  {
    id: 'row4',
    country: { value: 'ANGOLA' },
    code: { value: 'AO' },
    locales: { value: ['en_AO', 'fr_AO', 'es_AO', 'zh_AO'] },
  },
  {
    id: 'row5',
    country: { value: 'ANGUILLA' },
    code: { value: 'AI' },
    locales: { value: ['en_AI', 'fr_AI', 'es_AI', 'zh_AI'] },
  },
  {
    id: 'row6',
    country: { value: 'ANTIGUA & BARBUDA' },
    code: { value: 'AG' },
    locales: { value: ['en_AG', 'fr_AG', 'es_AG', 'zh_AG'] },
  },
  {
    id: 'row7',
    country: { value: 'ARGENTINA' },
    code: { value: 'AR' },
    locales: { value: ['es_AR', 'en_AR'] },
  },
  {
    id: 'row8',
    country: { value: 'ARMENIA' },
    code: { value: 'AM' },
    locales: { value: ['en_AM', 'fr_AM', 'es_AM', 'zh_AM'] },
  },
  {
    id: 'row9',
    country: { value: 'ARUBA' },
    code: { value: 'AW' },
    locales: { value: ['en_AW', 'fr_AW', 'es_AW', 'zh_AW'] },
  },
  {
    id: 'row10',
    country: { value: 'AUSTRALIA' },
    code: { value: 'AU' },
    locales: { value: ['en_AU'] },
  },
  {
    id: 'row11',
    country: { value: 'AUSTRIA' },
    code: { value: 'AT' },
    locales: { value: ['de_AT', 'en_AT'] },
  },
  {
    id: 'row12',
    country: { value: 'AZERBAIJAN' },
    code: { value: 'AZ' },
    locales: { value: ['en_AZ', 'fr_AZ', 'es_AZ', 'zh_AZ'] },
  },
  {
    id: 'row13',
    country: { value: 'BAHAMAS' },
    code: { value: 'BS' },
    locales: { value: ['en_BS', 'fr_BS', 'es_BS', 'zh_BS'] },
  },
  {
    id: 'row14',
    country: { value: 'BAHRAIN' },
    code: { value: 'BH' },
    locales: { value: ['ar_BH', 'en_BH', 'fr_BH', 'es_BH', 'zh_BH'] },
  },
  {
    id: 'row15',
    country: { value: 'BARBADOS' },
    code: { value: 'BB' },
    locales: { value: ['en_BB', 'fr_BB', 'es_BB', 'zh_BB'] },
  },
  {
    id: 'row16',
    country: { value: 'BELARUS' },
    code: { value: 'BY' },
    locales: { value: ['en_BY'] },
  },
  {
    id: 'row17',
    country: { value: 'BELGIUM' },
    code: { value: 'BE' },
    locales: { value: ['en_BE', 'nl_BE', 'fr_BE'] },
  },
  {
    id: 'row18',
    country: { value: 'BELIZE' },
    code: { value: 'BZ' },
    locales: { value: ['en_BZ', 'es_BZ', 'fr_BZ', 'zh_BZ'] },
  },
  {
    id: 'row19',
    country: { value: 'BENIN' },
    code: { value: 'BJ' },
    locales: { value: ['fr_BJ', 'en_BJ', 'es_BJ', 'zh_BJ'] },
  },
  {
    id: 'row20',
    country: { value: 'BERMUDA' },
    code: { value: 'BM' },
    locales: { value: ['en_BM', 'fr_BM', 'es_BM', 'zh_BM'] },
  },
  {
    id: 'row21',
    country: { value: 'BHUTAN' },
    code: { value: 'BT' },
    locales: { value: ['en_BT'] },
  },
  {
    id: 'row22',
    country: { value: 'BOLIVIA' },
    code: { value: 'BO' },
    locales: { value: ['es_BO', 'en_BO', 'fr_BO', 'zh_BO'] },
  },
  {
    id: 'row23',
    country: { value: 'BOSNIA & HERZEGOVINA' },
    code: { value: 'BA' },
    locales: { value: ['en_BA'] },
  },
  {
    id: 'row24',
    country: { value: 'BOTSWANA' },
    code: { value: 'BW' },
    locales: { value: ['en_BW', 'fr_BW', 'es_BW', 'zh_BW'] },
  },
  {
    id: 'row25',
    country: { value: 'BRAZIL' },
    code: { value: 'BR' },
    locales: { value: ['pt_BR', 'en_BR'] },
  },
  {
    id: 'row26',
    country: { value: 'BRITISH VIRGIN ISLANDS' },
    code: { value: 'VG' },
    locales: { value: ['en_VG', 'fr_VG', 'es_VG', 'zh_VG'] },
  },
  {
    id: 'row27',
    country: { value: 'BRUNEI' },
    code: { value: 'BN' },
    locales: { value: ['en_BN'] },
  },
  {
    id: 'row28',
    country: { value: 'BULGARIA' },
    code: { value: 'BG' },
    locales: { value: ['en_BG'] },
  },
  {
    id: 'row29',
    country: { value: 'BURKINA FASO' },
    code: { value: 'BF' },
    locales: { value: ['fr_BF', 'en_BF', 'es_BF', 'zh_BF'] },
  },
  {
    id: 'row30',
    country: { value: 'BURUNDI' },
    code: { value: 'BI' },
    locales: { value: ['fr_BI', 'en_BI', 'es_BI', 'zh_BI'] },
  },
  {
    id: 'row31',
    country: { value: 'CAMBODIA' },
    code: { value: 'KH' },
    locales: { value: ['en_KH'] },
  },
  {
    id: 'row32',
    country: { value: 'CAMEROON' },
    code: { value: 'CM' },
    locales: { value: ['fr_CM', 'en_CM'] },
  },
  {
    id: 'row33',
    country: { value: 'CANADA' },
    code: { value: 'CA' },
    locales: { value: ['en_CA', 'fr_CA'] },
  },
  {
    id: 'row34',
    country: { value: 'CAPE VERDE' },
    code: { value: 'CV' },
    locales: { value: ['en_CV', 'fr_CV', 'es_CV', 'zh_CV'] },
  },
  {
    id: 'row35',
    country: { value: 'CAYMAN ISLANDS' },
    code: { value: 'KY' },
    locales: { value: ['en_KY', 'fr_KY', 'es_KY', 'zh_KY'] },
  },
  {
    id: 'row36',
    country: { value: 'CHAD' },
    code: { value: 'TD' },
    locales: { value: ['fr_TD', 'en_TD', 'es_TD', 'zh_TD'] },
  },
  {
    id: 'row37',
    country: { value: 'CHILE' },
    code: { value: 'CL' },
    locales: { value: ['es_CL', 'en_CL', 'fr_CL', 'zh_CL'] },
  },
  {
    id: 'row38',
    country: { value: 'CHINA' },
    code: { value: 'CN' },
    locales: { value: ['zh_CN'] },
  },
  {
    id: 'row39',
    country: { value: 'COLOMBIA' },
    code: { value: 'CO' },
    locales: { value: ['es_CO', 'en_CO', 'fr_CO', 'zh_CO'] },
  },
  {
    id: 'row40',
    country: { value: 'COMOROS' },
    code: { value: 'KM' },
    locales: { value: ['fr_KM', 'en_KM', 'es_KM', 'zh_KM'] },
  },
  {
    id: 'row41',
    country: { value: 'CONGO-BRAZZAVILLE' },
    code: { value: 'CG' },
    locales: { value: ['en_CG', 'fr_CG', 'es_CG', 'zh_CG'] },
  },
  {
    id: 'row42',
    country: { value: 'CONGO-KINSHASA' },
    code: { value: 'CD' },
    locales: { value: ['fr_CD', 'en_CD', 'es_CD', 'zh_CD'] },
  },
  {
    id: 'row43',
    country: { value: 'COOK ISLANDS' },
    code: { value: 'CK' },
    locales: { value: ['en_CK', 'fr_CK', 'es_CK', 'zh_CK'] },
  },
  {
    id: 'row44',
    country: { value: 'COSTA RICA' },
    code: { value: 'CR' },
    locales: { value: ['es_CR', 'en_CR', 'fr_CR', 'zh_CR'] },
  },
  {
    id: 'row45',
    country: { value: "CÔTE D'IVOIRE" },
    code: { value: 'CI' },
    locales: { value: ['fr_CI', 'en_CI'] },
  },
  {
    id: 'row46',
    country: { value: 'CROATIA' },
    code: { value: 'HR' },
    locales: { value: ['en_HR'] },
  },
  {
    id: 'row47',
    country: { value: 'CYPRUS' },
    code: { value: 'CY' },
    locales: { value: ['en_CY'] },
  },
  {
    id: 'row48',
    country: { value: 'CZECH REPUBLIC' },
    code: { value: 'CZ' },
    locales: { value: ['cs_CZ', 'en_CZ', 'fr_CZ', 'es_CZ', 'zh_CZ'] },
  },
  {
    id: 'row49',
    country: { value: 'DENMARK' },
    code: { value: 'DK' },
    locales: { value: ['da_DK', 'en_DK'] },
  },
  {
    id: 'row50',
    country: { value: 'DJIBOUTI' },
    code: { value: 'DJ' },
    locales: { value: ['fr_DJ', 'en_DJ', 'es_DJ', 'zh_DJ'] },
  },
  {
    id: 'row51',
    country: { value: 'DOMINICA' },
    code: { value: 'DM' },
    locales: { value: ['en_DM', 'fr_DM', 'es_DM', 'zh_DM'] },
  },
  {
    id: 'row52',
    country: { value: 'DOMINICAN REPUBLIC' },
    code: { value: 'DO' },
    locales: { value: ['es_DO', 'en_DO', 'fr_DO', 'zh_DO'] },
  },
  {
    id: 'row53',
    country: { value: 'ECUADOR' },
    code: { value: 'EC' },
    locales: { value: ['es_EC', 'en_EC', 'fr_EC', 'zh_EC'] },
  },
  {
    id: 'row54',
    country: { value: 'EGYPT' },
    code: { value: 'EG' },
    locales: { value: ['ar_EG', 'en_EG', 'fr_EG', 'es_EG', 'zh_EG'] },
  },
  {
    id: 'row55',
    country: { value: 'EL SALVADOR' },
    code: { value: 'SV' },
    locales: { value: ['es_SV', 'en_SV', 'fr_SV', 'zh_SV'] },
  },
  {
    id: 'row56',
    country: { value: 'ERITREA' },
    code: { value: 'ER' },
    locales: { value: ['en_ER', 'fr_ER', 'es_ER', 'zh_ER'] },
  },
  {
    id: 'row57',
    country: { value: 'ESTONIA' },
    code: { value: 'EE' },
    locales: { value: ['en_EE', 'ru_EE', 'fr_EE', 'es_EE', 'zh_EE'] },
  },
  {
    id: 'row58',
    country: { value: 'ETHIOPIA' },
    code: { value: 'ET' },
    locales: { value: ['en_ET', 'fr_ET', 'es_ET', 'zh_ET'] },
  },
  {
    id: 'row59',
    country: { value: 'FALKLAND ISLANDS' },
    code: { value: 'FK' },
    locales: { value: ['en_FK', 'fr_FK', 'es_FK', 'zh_FK'] },
  },
  {
    id: 'row60',
    country: { value: 'FAROE ISLANDS' },
    code: { value: 'FO' },
    locales: { value: ['da_FO', 'en_FO', 'fr_FO', 'es_FO', 'zh_FO'] },
  },
  {
    id: 'row61',
    country: { value: 'FIJI' },
    code: { value: 'FJ' },
    locales: { value: ['en_FJ', 'fr_FJ', 'es_FJ', 'zh_FJ'] },
  },
  {
    id: 'row62',
    country: { value: 'FINLAND' },
    code: { value: 'FI' },
    locales: { value: ['fi_FI', 'en_FI', 'fr_FI', 'es_FI', 'zh_FI'] },
  },
  {
    id: 'row63',
    country: { value: 'FRANCE' },
    code: { value: 'FR' },
    locales: { value: ['fr_FR', 'en_FR'] },
  },
  {
    id: 'row64',
    country: { value: 'FRENCH GUIANA' },
    code: { value: 'GF' },
    locales: { value: ['en_GF', 'fr_GF', 'es_GF', 'zh_GF'] },
  },
  {
    id: 'row65',
    country: { value: 'FRENCH POLYNESIA' },
    code: { value: 'PF' },
    locales: { value: ['en_PF', 'fr_PF', 'es_PF', 'zh_PF'] },
  },
  {
    id: 'row66',
    country: { value: 'GABON' },
    code: { value: 'GA' },
    locales: { value: ['fr_GA', 'en_GA', 'es_GA', 'zh_GA'] },
  },
  {
    id: 'row67',
    country: { value: 'GAMBIA' },
    code: { value: 'GM' },
    locales: { value: ['en_GM', 'fr_GM', 'es_GM', 'zh_GM'] },
  },
  {
    id: 'row68',
    country: { value: 'GEORGIA' },
    code: { value: 'GE' },
    locales: { value: ['en_GE', 'fr_GE', 'es_GE', 'zh_GE'] },
  },
  {
    id: 'row69',
    country: { value: 'GERMANY' },
    code: { value: 'DE' },
    locales: { value: ['de_DE', 'en_DE'] },
  },
  {
    id: 'row70',
    country: { value: 'GIBRALTAR' },
    code: { value: 'GI' },
    locales: { value: ['en_GI', 'fr_GI', 'es_GI', 'zh_GI'] },
  },
  {
    id: 'row71',
    country: { value: 'GREECE' },
    code: { value: 'GR' },
    locales: { value: ['el_GR', 'en_GR', 'fr_GR', 'es_GR', 'zh_GR'] },
  },
  {
    id: 'row72',
    country: { value: 'GREENLAND' },
    code: { value: 'GL' },
    locales: { value: ['da_GL', 'en_GL', 'fr_GL', 'es_GL', 'zh_GL'] },
  },
  {
    id: 'row73',
    country: { value: 'GRENADA' },
    code: { value: 'GD' },
    locales: { value: ['en_GD', 'fr_GD', 'es_GD', 'zh_GD'] },
  },
  {
    id: 'row74',
    country: { value: 'GUADELOUPE' },
    code: { value: 'GP' },
    locales: { value: ['en_GP', 'fr_GP', 'es_GP', 'zh_GP'] },
  },
  {
    id: 'row75',
    country: { value: 'GUATEMALA' },
    code: { value: 'GT' },
    locales: { value: ['es_GT', 'en_GT', 'fr_GT', 'zh_GT'] },
  },
  {
    id: 'row76',
    country: { value: 'GUINEA' },
    code: { value: 'GN' },
    locales: { value: ['fr_GN', 'en_GN', 'es_GN', 'zh_GN'] },
  },
  {
    id: 'row77',
    country: { value: 'GUINEA - BISSAU' },
    code: { value: 'GW' },
    locales: { value: ['en_GW', 'fr_GW', 'es_GW', 'zh_GW'] },
  },
  {
    id: 'row78',
    country: { value: 'GUYANA' },
    code: { value: 'GY' },
    locales: { value: ['en_GY', 'fr_GY', 'es_GY', 'zh_GY'] },
  },
  {
    id: 'row79',
    country: { value: 'HONDURAS' },
    code: { value: 'HN' },
    locales: { value: ['es_HN', 'en_HN', 'fr_HN', 'zh_HN'] },
  },
  {
    id: 'row80',
    country: { value: 'HONG KONG SAR CHINA' },
    code: { value: 'HK' },
    locales: { value: ['en_HK', 'zh_HK'] },
  },
  {
    id: 'row81',
    country: { value: 'HUNGARY' },
    code: { value: 'HU' },
    locales: { value: ['hu_HU', 'en_HU', 'fr_HU', 'es_HU', 'zh_HU'] },
  },
  {
    id: 'row82',
    country: { value: 'ICELAND' },
    code: { value: 'IS' },
    locales: { value: ['en_IS'] },
  },
  {
    id: 'row83',
    country: { value: 'INDIA' },
    code: { value: 'IN' },
    locales: { value: ['en_IN'] },
  },
  {
    id: 'row84',
    country: { value: 'INDONESIA' },
    code: { value: 'ID' },
    locales: { value: ['id_ID', 'en_ID'] },
  },
  {
    id: 'row85',
    country: { value: 'IRELAND' },
    code: { value: 'IE' },
    locales: { value: ['en_IE', 'fr_IE', 'es_IE', 'zh_IE'] },
  },
  {
    id: 'row86',
    country: { value: 'ISRAEL' },
    code: { value: 'IL' },
    locales: { value: ['he_IL', 'en_IL'] },
  },
  {
    id: 'row87',
    country: { value: 'ITALY' },
    code: { value: 'IT' },
    locales: { value: ['it_IT', 'en_IT'] },
  },
  {
    id: 'row88',
    country: { value: 'JAMAICA' },
    code: { value: 'JM' },
    locales: { value: ['en_JM', 'es_JM', 'fr_JM', 'zh_JM'] },
  },
  {
    id: 'row89',
    country: { value: 'JAPAN' },
    code: { value: 'JP' },
    locales: { value: ['ja_JP', 'en_JP'] },
  },
  {
    id: 'row90',
    country: { value: 'JORDAN' },
    code: { value: 'JO' },
    locales: { value: ['ar_JO', 'en_JO', 'fr_JO', 'es_JO', 'zh_JO'] },
  },
  {
    id: 'row91',
    country: { value: 'KAZAKHSTAN' },
    code: { value: 'KZ' },
    locales: { value: ['en_KZ', 'fr_KZ', 'es_KZ', 'zh_KZ'] },
  },
  {
    id: 'row92',
    country: { value: 'KENYA' },
    code: { value: 'KE' },
    locales: { value: ['en_KE', 'fr_KE', 'es_KE', 'zh_KE'] },
  },
  {
    id: 'row93',
    country: { value: 'KIRIBATI' },
    code: { value: 'KI' },
    locales: { value: ['en_KI', 'fr_KI', 'es_KI', 'zh_KI'] },
  },
  {
    id: 'row94',
    country: { value: 'KUWAIT' },
    code: { value: 'KW' },
    locales: { value: ['ar_KW', 'en_KW', 'fr_KW', 'es_KW', 'zh_KW'] },
  },
  {
    id: 'row95',
    country: { value: 'KYRGYZSTAN' },
    code: { value: 'KG' },
    locales: { value: ['en_KG', 'fr_KG', 'es_KG', 'zh_KG'] },
  },
  {
    id: 'row96',
    country: { value: 'LAOS' },
    code: { value: 'LA' },
    locales: { value: ['en_LA'] },
  },
  {
    id: 'row97',
    country: { value: 'LATVIA' },
    code: { value: 'LV' },
    locales: { value: ['en_LV', 'ru_LV', 'fr_LV', 'es_LV', 'zh_LV'] },
  },
  {
    id: 'row98',
    country: { value: 'LESOTHO' },
    code: { value: 'LS' },
    locales: { value: ['en_LS', 'fr_LS', 'es_LS', 'zh_LS'] },
  },
  {
    id: 'row99',
    country: { value: 'LIECHTENSTEIN' },
    code: { value: 'LI' },
    locales: { value: ['en_LI', 'fr_LI', 'es_LI', 'zh_LI'] },
  },
  {
    id: 'row100',
    country: { value: 'LITHUANIA' },
    code: { value: 'LT' },
    locales: { value: ['en_LT', 'ru_LT', 'fr_LT', 'es_LT', 'zh_LT'] },
  },
  {
    id: 'row101',
    country: { value: 'LUXEMBOURG' },
    code: { value: 'LU' },
    locales: { value: ['en_LU', 'de_LU', 'fr_LU', 'es_LU', 'zh_LU'] },
  },
  {
    id: 'row102',
    country: { value: 'MACEDONIA' },
    code: { value: 'MK' },
    locales: { value: ['en_MK'] },
  },
  {
    id: 'row103',
    country: { value: 'MADAGASCAR' },
    code: { value: 'MG' },
    locales: { value: ['en_MG', 'fr_MG', 'es_MG', 'zh_MG'] },
  },
  {
    id: 'row104',
    country: { value: 'MALAWI' },
    code: { value: 'MW' },
    locales: { value: ['en_MW', 'fr_MW', 'es_MW', 'zh_MW'] },
  },
  {
    id: 'row105',
    country: { value: 'MALAYSIA' },
    code: { value: 'MY' },
    locales: { value: ['en_MY'] },
  },
  {
    id: 'row106',
    country: { value: 'MALDIVES' },
    code: { value: 'MV' },
    locales: { value: ['en_MV'] },
  },
  {
    id: 'row107',
    country: { value: 'MALI' },
    code: { value: 'ML' },
    locales: { value: ['fr_ML', 'en_ML', 'es_ML', 'zh_ML'] },
  },
  {
    id: 'row108',
    country: { value: 'MALTA' },
    code: { value: 'MT' },
    locales: { value: ['en_MT'] },
  },
  {
    id: 'row109',
    country: { value: 'MARSHALL ISLANDS' },
    code: { value: 'MH' },
    locales: { value: ['en_MH', 'fr_MH', 'es_MH', 'zh_MH'] },
  },
  {
    id: 'row110',
    country: { value: 'MARTINIQUE' },
    code: { value: 'MQ' },
    locales: { value: ['en_MQ', 'fr_MQ', 'es_MQ', 'zh_MQ'] },
  },
  {
    id: 'row111',
    country: { value: 'MAURITANIA' },
    code: { value: 'MR' },
    locales: { value: ['en_MR', 'fr_MR', 'es_MR', 'zh_MR'] },
  },
  {
    id: 'row112',
    country: { value: 'MAURITIUS' },
    code: { value: 'MU' },
    locales: { value: ['en_MU', 'fr_MU', 'es_MU', 'zh_MU'] },
  },
  {
    id: 'row113',
    country: { value: 'MAYOTTE' },
    code: { value: 'YT' },
    locales: { value: ['en_YT', 'fr_YT', 'es_YT', 'zh_YT'] },
  },
  {
    id: 'row114',
    country: { value: 'MEXICO' },
    code: { value: 'MX' },
    locales: { value: ['es_MX', 'en_MX'] },
  },
  {
    id: 'row115',
    country: { value: 'MICRONESIA' },
    code: { value: 'FM' },
    locales: { value: ['en_FM'] },
  },
  {
    id: 'row116',
    country: { value: 'MOLDOVA' },
    code: { value: 'MD' },
    locales: { value: ['en_MD'] },
  },
  {
    id: 'row117',
    country: { value: 'MONACO' },
    code: { value: 'MC' },
    locales: { value: ['fr_MC', 'en_MC'] },
  },
  {
    id: 'row118',
    country: { value: 'MONGOLIA' },
    code: { value: 'MN' },
    locales: { value: ['en_MN'] },
  },
  {
    id: 'row119',
    country: { value: 'MONTENEGRO' },
    code: { value: 'ME' },
    locales: { value: ['en_ME'] },
  },
  {
    id: 'row120',
    country: { value: 'MONTSERRAT' },
    code: { value: 'MS' },
    locales: { value: ['en_MS', 'fr_MS', 'es_MS', 'zh_MS'] },
  },
  {
    id: 'row121',
    country: { value: 'MOROCCO' },
    code: { value: 'MA' },
    locales: { value: ['ar_MA', 'en_MA', 'fr_MA', 'es_MA', 'zh_MA'] },
  },
  {
    id: 'row122',
    country: { value: 'MOZAMBIQUE' },
    code: { value: 'MZ' },
    locales: { value: ['en_MZ', 'fr_MZ', 'es_MZ', 'zh_MZ'] },
  },
  {
    id: 'row123',
    country: { value: 'NAMIBIA' },
    code: { value: 'NA' },
    locales: { value: ['en_NA', 'fr_NA', 'es_NA', 'zh_NA'] },
  },
  {
    id: 'row124',
    country: { value: 'NAURU' },
    code: { value: 'NR' },
    locales: { value: ['en_NR', 'fr_NR', 'es_NR', 'zh_NR'] },
  },
  {
    id: 'row125',
    country: { value: 'NEPAL' },
    code: { value: 'NP' },
    locales: { value: ['en_NP'] },
  },
  {
    id: 'row126',
    country: { value: 'NETHERLANDS' },
    code: { value: 'NL' },
    locales: { value: ['nl_NL', 'en_NL'] },
  },
  {
    id: 'row127',
    country: { value: 'NETHERLANDS ANTILLES' },
    code: { value: 'AN' },
    locales: { value: ['en_AN', 'fr_AN', 'es_AN', 'zh_AN'] },
  },
  {
    id: 'row128',
    country: { value: 'NEW CALEDONIA' },
    code: { value: 'NC' },
    locales: { value: ['en_NC', 'fr_NC', 'es_NC', 'zh_NC'] },
  },
  {
    id: 'row129',
    country: { value: 'NEW ZEALAND' },
    code: { value: 'NZ' },
    locales: { value: ['en_NZ', 'fr_NZ', 'es_NZ', 'zh_NZ'] },
  },
  {
    id: 'row130',
    country: { value: 'NICARAGUA' },
    code: { value: 'NI' },
    locales: { value: ['es_NI', 'en_NI', 'fr_NI', 'zh_NI'] },
  },
  {
    id: 'row131',
    country: { value: 'NIGER' },
    code: { value: 'NE' },
    locales: { value: ['fr_NE', 'en_NE', 'es_NE', 'zh_NE'] },
  },
  {
    id: 'row132',
    country: { value: 'NIGERIA' },
    code: { value: 'NG' },
    locales: { value: ['en_NG'] },
  },
  {
    id: 'row133',
    country: { value: 'NIUE' },
    code: { value: 'NU' },
    locales: { value: ['en_NU', 'fr_NU', 'es_NU', 'zh_NU'] },
  },
  {
    id: 'row134',
    country: { value: 'NORFOLK ISLAND' },
    code: { value: 'NF' },
    locales: { value: ['en_NF', 'fr_NF', 'es_NF', 'zh_NF'] },
  },
  {
    id: 'row135',
    country: { value: 'NORWAY' },
    code: { value: 'NO' },
    locales: { value: ['no_NO', 'en_NO'] },
  },
  {
    id: 'row136',
    country: { value: 'OMAN' },
    code: { value: 'OM' },
    locales: { value: ['ar_OM', 'en_OM', 'fr_OM', 'es_OM', 'zh_OM'] },
  },
  {
    id: 'row137',
    country: { value: 'PALAU' },
    code: { value: 'PW' },
    locales: { value: ['en_PW', 'fr_PW', 'es_PW', 'zh_PW'] },
  },
  {
    id: 'row138',
    country: { value: 'PANAMA' },
    code: { value: 'PA' },
    locales: { value: ['es_PA', 'en_PA', 'fr_PA', 'zh_PA'] },
  },
  {
    id: 'row139',
    country: { value: 'PAPAUA NEW GUINEA' },
    code: { value: 'PG' },
    locales: { value: ['en_PG', 'fr_PG', 'es_PG', 'zh_PG'] },
  },
  {
    id: 'row140',
    country: { value: 'PARAGUAY' },
    code: { value: 'PY' },
    locales: { value: ['es_PY', 'en_PY'] },
  },
  {
    id: 'row141',
    country: { value: 'PERU' },
    code: { value: 'PE' },
    locales: { value: ['es_PE', 'en_PE', 'fr_PE', 'zh_PE'] },
  },
  {
    id: 'row142',
    country: { value: 'PHILIPPINES' },
    code: { value: 'PH' },
    locales: { value: ['en_PH'] },
  },
  {
    id: 'row143',
    country: { value: 'PITCAIRN ISLANDS' },
    code: { value: 'PN' },
    locales: { value: ['en_PN', 'fr_PN', 'es_PN', 'zh_PN'] },
  },
  {
    id: 'row144',
    country: { value: 'POLAND' },
    code: { value: 'PL' },
    locales: { value: ['pl_PL', 'en_PL'] },
  },
  {
    id: 'row145',
    country: { value: 'PORTUGAL' },
    code: { value: 'PT' },
    locales: { value: ['pt_PT', 'en_PT'] },
  },
  {
    id: 'row146',
    country: { value: 'QATAR' },
    code: { value: 'QA' },
    locales: { value: ['en_QA', 'fr_QA', 'es_QA', 'zh_QA', 'ar_QA'] },
  },
  {
    id: 'row147',
    country: { value: 'RÉUNION' },
    code: { value: 'RE' },
    locales: { value: ['en_RE', 'fr_RE', 'es_RE', 'zh_RE'] },
  },
  {
    id: 'row148',
    country: { value: 'ROMANIA' },
    code: { value: 'RO' },
    locales: { value: ['en_RO', 'fr_RO', 'es_RO', 'zh_RO'] },
  },
  {
    id: 'row149',
    country: { value: 'RUSSIA' },
    code: { value: 'RU' },
    locales: { value: ['ru_RU', 'en_RU'] },
  },
  {
    id: 'row150',
    country: { value: 'RWANDA' },
    code: { value: 'RW' },
    locales: { value: ['fr_RW', 'en_RW', 'es_RW', 'zh_RW'] },
  },
  {
    id: 'row151',
    country: { value: 'SAMOA' },
    code: { value: 'WS' },
    locales: { value: ['en_WS'] },
  },
  {
    id: 'row152',
    country: { value: 'SAN MARINO' },
    code: { value: 'SM' },
    locales: { value: ['en_SM', 'fr_SM', 'es_SM', 'zh_SM'] },
  },
  {
    id: 'row153',
    country: { value: 'SÃO TOMÉ & PRÍNCIPE' },
    code: { value: 'ST' },
    locales: { value: ['en_ST', 'fr_ST', 'es_ST', 'zh_ST'] },
  },
  {
    id: 'row154',
    country: { value: 'SAUDI ARABIA' },
    code: { value: 'SA' },
    locales: { value: ['ar_SA', 'en_SA', 'fr_SA', 'es_SA', 'zh_SA'] },
  },
  {
    id: 'row155',
    country: { value: 'SENEGAL' },
    code: { value: 'SN' },
    locales: { value: ['fr_SN', 'en_SN', 'es_SN', 'zh_SN'] },
  },
  {
    id: 'row156',
    country: { value: 'SERBIA' },
    code: { value: 'RS' },
    locales: { value: ['en_RS', 'fr_RS', 'es_RS', 'zh_RS'] },
  },
  {
    id: 'row157',
    country: { value: 'SEYCHELLES' },
    code: { value: 'SC' },
    locales: { value: ['fr_SC', 'en_SC', 'es_SC', 'zh_SC'] },
  },
  {
    id: 'row158',
    country: { value: 'SIERRA LEONE' },
    code: { value: 'SL' },
    locales: { value: ['en_SL', 'fr_SL', 'es_SL', 'zh_SL'] },
  },
  {
    id: 'row159',
    country: { value: 'SINGAPORE' },
    code: { value: 'SG' },
    locales: { value: ['en_SG'] },
  },
  {
    id: 'row160',
    country: { value: 'SLOVAKIA' },
    code: { value: 'SK' },
    locales: { value: ['sk_SK', 'en_SK', 'fr_SK', 'es_SK', 'zh_SK'] },
  },
  {
    id: 'row161',
    country: { value: 'SLOVENIA' },
    code: { value: 'SI' },
    locales: { value: ['en_SI', 'fr_SI', 'es_SI', 'zh_SI'] },
  },
  {
    id: 'row162',
    country: { value: 'SOLOMON ISLANDS' },
    code: { value: 'SB' },
    locales: { value: ['en_SB', 'fr_SB', 'es_SB', 'zh_SB'] },
  },
  {
    id: 'row163',
    country: { value: 'SOMALIA' },
    code: { value: 'SO' },
    locales: { value: ['en_SO', 'fr_SO', 'es_SO', 'zh_SO'] },
  },
  {
    id: 'row164',
    country: { value: 'SOUTH AFRICA' },
    code: { value: 'ZA' },
    locales: { value: ['en_ZA', 'fr_ZA', 'es_ZA', 'zh_ZA'] },
  },
  {
    id: 'row165',
    country: { value: 'SOUTH KOREA' },
    code: { value: 'KR' },
    locales: { value: ['ko_KR', 'en_KR'] },
  },
  {
    id: 'row166',
    country: { value: 'SPAIN' },
    code: { value: 'ES' },
    locales: { value: ['es_ES', 'en_ES'] },
  },
  {
    id: 'row167',
    country: { value: 'SRI LANKA' },
    code: { value: 'LK' },
    locales: { value: ['en_LK'] },
  },
  {
    id: 'row168',
    country: { value: 'ST. HELENA' },
    code: { value: 'SH' },
    locales: { value: ['en_SH', 'fr_SH', 'es_SH', 'zh_SH'] },
  },
  {
    id: 'row169',
    country: { value: 'ST. KITTS & NEVIS' },
    code: { value: 'KN' },
    locales: { value: ['en_KN', 'fr_KN', 'es_KN', 'zh_KN'] },
  },
  {
    id: 'row170',
    country: { value: 'ST. LUCIA' },
    code: { value: 'LC' },
    locales: { value: ['en_LC', 'fr_LC', 'es_LC', 'zh_LC'] },
  },
  {
    id: 'row171',
    country: { value: 'ST. PIERRE & MIQUELON' },
    code: { value: 'PM' },
    locales: { value: ['en_PM', 'fr_PM', 'es_PM', 'zh_PM'] },
  },
  {
    id: 'row172',
    country: { value: 'ST. VINCENT & GRENADINES' },
    code: { value: 'VC' },
    locales: { value: ['en_VC', 'fr_VC', 'es_VC', 'zh_VC'] },
  },
  {
    id: 'row173',
    country: { value: 'SURINAME' },
    code: { value: 'SR' },
    locales: { value: ['en_SR', 'fr_SR', 'es_SR', 'zh_SR'] },
  },
  {
    id: 'row174',
    country: { value: 'SVALBARD & JAN MAYEN' },
    code: { value: 'SJ' },
    locales: { value: ['en_SJ', 'fr_SJ', 'es_SJ', 'zh_SJ'] },
  },
  {
    id: 'row175',
    country: { value: 'SWAZILAND' },
    code: { value: 'SZ' },
    locales: { value: ['en_SZ', 'fr_SZ', 'es_SZ', 'zh_SZ'] },
  },
  {
    id: 'row176',
    country: { value: 'SWEDEN' },
    code: { value: 'SE' },
    locales: { value: ['sv_SE', 'en_SE'] },
  },
  {
    id: 'row177',
    country: { value: 'SWITZERLAND' },
    code: { value: 'CH' },
    locales: { value: ['de_CH', 'fr_CH', 'en_CH'] },
  },
  {
    id: 'row178',
    country: { value: 'TAIWAN' },
    code: { value: 'TW' },
    locales: { value: ['zh_TW', 'en_TW'] },
  },
  {
    id: 'row179',
    country: { value: 'TAJIKISTAN' },
    code: { value: 'TJ' },
    locales: { value: ['en_TJ', 'fr_TJ', 'es_TJ', 'zh_TJ'] },
  },
  {
    id: 'row180',
    country: { value: 'TANZANIA' },
    code: { value: 'TZ' },
    locales: { value: ['en_TZ', 'fr_TZ', 'es_TZ', 'zh_TZ'] },
  },
  {
    id: 'row181',
    country: { value: 'THAILAND' },
    code: { value: 'TH' },
    locales: { value: ['th_TH', 'en_TH'] },
  },
  {
    id: 'row182',
    country: { value: 'TOGO' },
    code: { value: 'TG' },
    locales: { value: ['fr_TG', 'en_TG', 'es_TG', 'zh_TG'] },
  },
  {
    id: 'row183',
    country: { value: 'TONGA' },
    code: { value: 'TO' },
    locales: { value: ['en_TO'] },
  },
  {
    id: 'row184',
    country: { value: 'TRINIDAD & TOBAGO' },
    code: { value: 'TT' },
    locales: { value: ['en_TT', 'fr_TT', 'es_TT', 'zh_TT'] },
  },
  {
    id: 'row185',
    country: { value: 'TUNISIA' },
    code: { value: 'TN' },
    locales: { value: ['ar_TN', 'en_TN', 'fr_TN', 'es_TN', 'zh_TN'] },
  },
  {
    id: 'row186',
    country: { value: 'TURKMENISTAN' },
    code: { value: 'TM' },
    locales: { value: ['en_TM', 'fr_TM', 'es_TM', 'zh_TM'] },
  },
  {
    id: 'row187',
    country: { value: 'TURKS & CAICOS ISLANDS' },
    code: { value: 'TC' },
    locales: { value: ['en_TC', 'fr_TC', 'es_TC', 'zh_TC'] },
  },
  {
    id: 'row188',
    country: { value: 'TUVALU' },
    code: { value: 'TV' },
    locales: { value: ['en_TV', 'fr_TV', 'es_TV', 'zh_TV'] },
  },
  {
    id: 'row189',
    country: { value: 'TURKEY' },
    code: { value: 'TR' },
    locales: { value: ['tr_TR', 'en_TR'] },
  },
  {
    id: 'row190',
    country: { value: 'UGANDA' },
    code: { value: 'UG' },
    locales: { value: ['en_UG', 'fr_UG', 'es_UG', 'zh_UG'] },
  },
  {
    id: 'row191',
    country: { value: 'UKRAINE' },
    code: { value: 'UA' },
    locales: { value: ['en_UA', 'ru_UA', 'fr_UA', 'es_UA', 'zh_UA'] },
  },
  {
    id: 'row192',
    country: { value: 'UNITED ARAB EMIRATES' },
    code: { value: 'AE' },
    locales: { value: ['en_AE', 'fr_AE', 'es_AE', 'zh_AE', 'ar_AE'] },
  },
  {
    id: 'row193',
    country: { value: 'UNITED KINGDOM' },
    code: { value: 'GB' },
    locales: { value: ['en_GB'] },
  },
  {
    id: 'row194',
    country: { value: 'UNITED STATES' },
    code: { value: 'US' },
    locales: { value: ['en_US', 'fr_US', 'es_US', 'zh_US'] },
  },
  {
    id: 'row195',
    country: { value: 'URUGUAY' },
    code: { value: 'UY' },
    locales: { value: ['es_UY', 'en_UY', 'fr_UY', 'zh_UY'] },
  },
  {
    id: 'row196',
    country: { value: 'VANUATU' },
    code: { value: 'VU' },
    locales: { value: ['en_VU', 'fr_VU', 'es_VU', 'zh_VU'] },
  },
  {
    id: 'row197',
    country: { value: 'VATICAN CITY' },
    code: { value: 'VA' },
    locales: { value: ['en_VA', 'fr_VA', 'es_VA', 'zh_VA'] },
  },
  {
    id: 'row198',
    country: { value: 'VENEZUELA' },
    code: { value: 'VE' },
    locales: { value: ['es_VE', 'en_VE', 'fr_VE', 'zh_VE'] },
  },
  {
    id: 'row199',
    country: { value: 'VIETNAM' },
    code: { value: 'VN' },
    locales: { value: ['en_VN'] },
  },
  {
    id: 'row200',
    country: { value: 'WALLIS & FUTUNA' },
    code: { value: 'WF' },
    locales: { value: ['en_WF', 'fr_WF', 'es_WF', 'zh_WF'] },
  },
  {
    id: 'row201',
    country: { value: 'YEMEN' },
    code: { value: 'YE' },
    locales: { value: ['ar_YE', 'en_YE', 'fr_YE', 'es_YE', 'zh_YE'] },
  },
  {
    id: 'row202',
    country: { value: 'ZAMBIA' },
    code: { value: 'ZM' },
    locales: { value: ['en_ZM', 'fr_ZM', 'es_ZM', 'zh_ZM'] },
  },
  {
    id: 'row203',
    country: { value: 'ZIMBABWE' },
    code: { value: 'ZW' },
    locales: { value: ['en_ZW'] },
  },
]

const columns = {
  country: {
    title: 'Country',
    width: '33%',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  code: {
    title: 'Code',
    cellAs: CodeCell,
    mobile: {
      placement: 'b3',
    },
  },
  locales: {
    title: 'Locale',
    cellAs: LocaleCell,
    mobile: {
      placement: 'b3',
    },
  },
}

const options = {
  threshold: 0.2,
  keys: ['country.value', 'code.value', 'locales.value'],
}

const fuse = new Fuse(allRows, options)

const CountryTable = () => {
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const showSeeMoreBtn = rows.length < allRows.length
  const [filteredRows, setFilteredRows] = useState([])

  useEffect(() => {
    if (searchInput) {
      setFilteredRows(fuse.search(searchInput).map(({ item }) => item))
    } else {
      setFilteredRows([])
    }
  }, [searchInput])

  const handleTextChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleSeeMore = () => {
    setSearchInput('')
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      <TextInput
        name="basic"
        value={searchInput}
        label="Search table"
        labelClassName="test"
        onKeyUp={handleTextChange}
      />
      <DataTable
        description="Basic"
        rows={searchInput ? filteredRows : rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default CountryTable
